import { render } from "./HomeView.vue?vue&type=template&id=c852ce74"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/orvux/Devel/JACons/Clientes/Rhinos/rhinos-pos/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__